"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSourceEnum = void 0;
var SubscriptionSourceEnum;
(function (SubscriptionSourceEnum) {
    SubscriptionSourceEnum["Stripe"] = "stripe";
    SubscriptionSourceEnum["Apple"] = "apple";
})(SubscriptionSourceEnum = exports.SubscriptionSourceEnum || (exports.SubscriptionSourceEnum = {}));
//# sourceMappingURL=subscription-source-enum.js.map